import styled, { css } from 'styled-components';

export const Header = styled.header`
  ${({ theme }) => css`
    color: ${theme.color.white};
    background: ${theme.color.primary};
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.7rem;

    h2 {
      font-size: 1.4rem;
      font-weight: ${theme.font.weight.bold};
      letter-spacing: -0.03rem;
      color: ${theme.color.white};
    }

    @media (max-width: 768px) {
      h2 {
        font-size: 1.8rem;
      }
    }
  `}
`;

export const HeaderTotal = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.white};
    display: flex;
    align-items: center;

    svg {
      width: 1.38rem;
      height: 1.324rem;
      margin-right: 0.75rem;
    }

    p {
      font-size: 1.4rem;
      font-weight: ${theme.font.weight.regular};
    }

    @media (max-width: 768px) {
      p {
        font-size: 1.6rem;
      }
    }
  `}
`;

export const TicketWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.color.white};

    > p {
      text-align: center;
      font-size: 1.2rem;
      padding: 1.5rem 0;
    }
  `}
`;

export const Ticket = styled.article`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem;
    border-bottom: 1px solid ${theme.color.background};

    .header {
      padding-right: 3.3rem;

      .title {
        font-size: 1.4rem;
        font-weight: ${theme.font.weight.medium};
        color: ${theme.color.primary};
      }

      .expired-at {
        font-size: 1.2rem;
        font-weight: ${theme.font.weight.light};
        color: ${theme.color.primary};
      }

      .amount {
        font-size: 1.2rem;
        font-weight: ${theme.font.weight.light};
        color: ${theme.color.text};
      }

      .installments {
        font-size: 1.2rem;
        font-weight: ${theme.font.weight.bold};
        color: ${theme.color.text};
      }
    }

    .actions {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      align-items: center;
      padding: 0.4rem;

      .total {
        margin: 0 1rem;
        color: ${theme.color.primary};
        font-size: 1.4rem;
        font-weight: ${theme.font.weight.bold};
        font-family: monospace;
      }

      img {
        min-width: 30px;
        min-height: 30px;
        padding: 0.2rem;
      }
    }

    @media (max-width: 768px) {
      .header {
        .title {
          font-size: 1.4rem;
        }
        .amount {
          font-size: 1.2rem;
        }
      }

      .actions {
        .total {
          font-size: 1.4rem;
        }
      }
    }
  `}
`;

export const PromoCode = styled.div<{ status: string }>`
  ${({ theme, status }) => css`
    background-color: ${theme.color.white};
    border-bottom: 1px solid ${theme.color.background};
    padding: 1.2rem 0.8rem;

    display: ${status === 'active' ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    gap: 0.4rem;

    > * {
      font-size: 1.3rem;
      border: 1px solid ${theme.color.primary};
      padding: 0 0.6rem;
      color: ${theme.color.primary};
      line-height: 2rem;
    }

    > button {
      padding-right: 0;
      > span {
        color: ${theme.color.white};
        padding: 0 0.2rem;
        margin-left: 0.6rem;
        background-color: ${theme.color.primary};
      }
    }

    @media (max-width: 768px) {
      > * {
        font-size: 1.4rem;
        padding: 0 0.8rem;
        line-height: 2.4rem;
      }
    }
  `}
`;

export const Amounts = styled.section`
  ${({ theme }) => css`
    padding: 1.5rem;
    background-color: ${theme.color.white};
    text-align: end;
    border-bottom: 1px solid ${theme.color.background};

    p {
      font-size: 1.2rem;
    }

    .sub-total {
      color: ${theme.color.primary};
      font-weight: 600;
      font-size: 1.6rem;
    }
  `}
`;

export const Footer = styled.div<{ status: string }>`
  ${({ theme, status }) => css`
    background-color: ${theme.color.white};
    display: ${status === 'active' ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
    padding: 0.8rem 0;

    button {
      width: 70%;
      display: block;
      font-size: 1.2rem;
      padding: 1.6rem;
      border-radius: 0.2rem;
    }
  `}
`;
